import React, { FC } from 'react';
import { DeliveryStatus as DeliveryStatusEnum } from '@fdha/graphql-api-admin';
import { SectionType } from '@fdha/common-utils';

import { ReviewDelivery } from '../../../components/delivery';

interface ReviewEditDeliveryPageProps {
  patientId: string;
  deliveryMenuId: string;
  deliveryId?: string;
  foodProgramUserId?: string;
  status?: DeliveryStatusEnum | null;
  isCanceled?: boolean;
  showWeekMenu?: boolean;
  onAddItems?: (itemType: SectionType) => void;
}

export const ReviewEditDeliveryPage: FC<ReviewEditDeliveryPageProps> = ({
  patientId,
  deliveryMenuId,
  deliveryId = '',
  foodProgramUserId = '',
  status,
  isCanceled = false,
  showWeekMenu = false,
  onAddItems,
}) => {
  return (
    <ReviewDelivery
      deliveryId={deliveryId}
      patientId={patientId}
      foodProgramUserId={foodProgramUserId}
      deliveryMenuId={deliveryMenuId}
      status={status}
      isCanceled={isCanceled}
      showWeekMenu={showWeekMenu}
      onAddItems={onAddItems}
    />
  );
};

export default ReviewEditDeliveryPage;
